export default {
  reCaptchaKey:
    process.env.GOOGLE_RECAPTCHA_SITE_KEY ||
    '6LcGtUIdAAAAALvhA79x5k1BHpnrB2ZsZQgBuaLY',
  gtmKey: process.env.GOOGLE_GTM_KEY || 'GTM-KX76RZC',
}
